export const FETCH_ALL_ADMIN_SUCCESS = "FETCH_ALL_ADMIN_SUCCESS";
export const FETCH_ALL_ADMIN_ERROR = "FETCH_ALL_ADMIN_ERROR";

